import React, { useState } from "react";
import "./Header.scss";
import NCLOGO from "./Logo.png";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCaretDown } from "react-icons/fa";
import { FaUserAlt } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { FaUser } from "react-icons/fa";
const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [ShowTooltip, setShowTooltip] = useState();
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const isActive = (path) => location.pathname.includes(path);
    return (
        <>
            <div className="Home-Header-Maindiv">
                <div className="dflex alignitems JSBetween Logos">
                    <img src={NCLOGO} alt="NCLLogo" className="LOGO" />


                    <div className="HMenu dflex alignitems gap-3 " >
                        <span onClick={() => navigate("/")} >Home</span>
                        {/* className={isActive("/") && "Web-Header-Active"} */}
                        <span onClick={() => navigate("/Competency Base Learning")} className={isActive("/Competency") && "Web-Header-Active"}> Competency based learning </span>
                        <span onClick={() => navigate("/NCP Teams")} className={isActive("/NCP%20Teams") && "Web-Header-Active"}> Team </span>
                        <span style={{ position: "relative" }} 
                            onMouseEnter={() => setShowTooltip("Gallery")}
                            onMouseLeave={() => setShowTooltip()}
                        > <span className="dflex alignitems JCCenter gap-1">Gallery <IoIosArrowDown /></span>
                            {ShowTooltip === "Gallery" && (
                                <div className="Card dflex flexd-column SubMenu p-0"  >
                                    <span onClick={() => navigate("/PhotoGallery")} style={isActive("/PhotoGallery") ? { color: "#347462" } : {}}
                                    > Photo Gallery </span>

                                    <span onClick={() => navigate("/VideoGallery")} style={isActive("/VideoGallery") ? { color: "#347462" } : {}}
                                    > Video Gallery </span>

                                    <span
                                        onClick={() => navigate("/Brochures")}
                                        style={isActive("/Brochures") ? { color: "#347462" } : {}}
                                    >
                                        Brochures
                                    </span>
                                    <span onClick={() => navigate("/AnnualReports")}
                                        style={isActive("/AnnualReports") ? { color: "#347462" } : {}}
                                    >
                                        Annual Reports
                                    </span>
                                    <span /*onClick={()=>navigate("/Events")} style={isActive("/Events") ? { color: "#3498db"} : {}}*/
                                    >
                                        Events
                                    </span>
                                </div>
                            )}
                        </span>
                    </div>

                    <div className="NSF-SItes dflex gap-3">
                        <span onClick={() => window.open("https://www.northsouth.org/", "_blank")} > NSF USA </span>
                        <span onClick={() => window.open("https://india.northsouth.org/", "_blank")} > NSF INDIA </span>
                    </div>
                    <div className="dflex alignitems">
                        <div className=" dflex gap-3 DL_Buttons">
                            <button className="Website-Buttons" onClick={() => navigate("/Donate")} > Donate </button>
                             <button className="Website-Buttons" onClick={() => navigate("/Login")}
                                // style={{ position: "relative" }}
                                // onMouseEnter={() => setShowTooltip("Login")}
                                // onMouseLeave={() => setShowTooltip()}
                            > <FaUser/> Admin
                                {/* {ShowTooltip === "Login" && (
                                    <div className="Card dflex flexd-column alignitems SubMenu p-0" style={{ top: "100%" }}>
                                        <span className="dflex alignitems gap-2 fw-normal" onClick={() => window.open("https://ncpassessments.northsouth.org/Login", "_blank")} > <PiStudentFill/> Student </span>
                                        <span className="dflex alignitems gap-2 fw-normal" onClick={() => navigate("/Login")} style={isActive("/Login") ? { color: "#347462" } : {}}
                                        ><FaUser/> Admin </span>
                                    </div>
                                )} */}
                            </button>
                            <button className="Website-Buttons" onClick={() => window.open(process.env.REACT_APP_AssessmentUrl, "_blank")}
                                // style={{ position: "relative" }}
                                // onMouseEnter={() => setShowTooltip("Login")}
                                // onMouseLeave={() => setShowTooltip()}
                            > <PiStudentFill/> Student
                                {/* {ShowTooltip === "Login" && (
                                    <div className="Card dflex flexd-column alignitems SubMenu p-0" style={{ top: "100%" }}>
                                        <span className="dflex alignitems gap-2 fw-normal" onClick={() => window.open("https://ncpassessments.northsouth.org/Login", "_blank")} > <PiStudentFill/> Student </span>
                                        <span className="dflex alignitems gap-2 fw-normal" onClick={() => navigate("/Login")} style={isActive("/Login") ? { color: "#347462" } : {}}
                                        ><FaUser/> Admin </span>
                                    </div>
                                )} */}
                            </button>
                           
                                                        {/* <button className="Website-Buttons" onClick={() => navigate("/Login")}> Log in </button> */}
                            <button className="Website-Buttons " onClick={() => window.open("/PracticeTest", "_blank")}> Practice Test </button>
                        </div>
                        <button className="menu-toggle" onClick={toggleMenu}> <IoMdMenu /> </button>
                    </div>
                </div>


            </div>
            <div className={`sidebar ${isMenuOpen ? "open" : ""}`}>
                <button className="close-btn" onClick={toggleMenu}>
                    <IoMdClose />{" "}
                </button>
                <div
                    className="dflex flexd-column gap-3 "
                    style={{ alignItems: "flex-start" }}
                >
                    <span onClick={() => navigate("/")}>Home</span>
                    <span onClick={() => navigate("/Competency Base Learning")}> Competency based learning </span>
                    <span onClick={() => navigate("/NCP Teams")}> Team </span>
                    <span style={{ position: "relative" }}
                        onClick={() => setShowTooltip(ShowTooltip === "Gallery" ? "" : "Gallery")}
                    >
                        Gallery <IoIosArrowDown />
                        {ShowTooltip === "Gallery" && (
                            <div className="Card dflex flexd-column SubMenu mt-1">
                                <span onClick={() => navigate("/PhotoGallery")}> Photo Gallery </span>
                                <span onClick={() => navigate("/VideoGallery")}> Video Gallery </span>
                                <span onClick={() => navigate("/Brochures")}>Brochures</span>
                                <span onClick={() => navigate("/AnnualReports")}> Annual Reports </span>
                                <span >Events</span>
                            </div>
                        )}
                    </span>
                    <div className="Side_NSF-SItes dflex gap-3 flexd-column w-100">
                        <span onClick={() => window.open("https://www.northsouth.org/", "_blank")} > NSF USA </span>
                        <span onClick={() => window.open("https://india.northsouth.org/", "_blank")} > NSF INDIA </span>
                    </div>
                    <div className=" dflex gap-3 Side_DL_Buttons flexd-column w-100">
                        <button className="Website-Buttons " onClick={() => navigate("/Donate")} > Donate </button>
                        <button className="Website-Buttons " style={{ position: "relative" }}
                        onClick={() => setShowTooltip(ShowTooltip === "Login" ? "" : "Login")}> Log in <IoIosArrowDown />
                        {ShowTooltip === "Login" && (
                            <div className="Card dflex flexd-column SubMenu mt-1" style={{top:"100%"}}>
                               <span onClick={() => window.open("https://ncpassessments.northsouth.org/Login", "_blank")} > Student Login </span>
                                        <span onClick={() => navigate("/Login")} style={isActive("/Login") ? { color: "#347462" } : {}}
                                        > Admin Login </span>
                            </div>
                        )}
                         </button>
                          {/* <button className="Website-Buttons " onClick={() => navigate("/Login")} > Log in </button> */}
                        <button className="Website-Buttons " onClick={() => window.open("/PracticeTest", "_blank")}> Practice Test </button>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Header;